module.exports = __webpack_public_path__ + "static/importantInfoAndActionsNo-e68bf711f8390b528581971f0a987c5d.png";